import DahabCredentialsList from './List';

function DahabCredentialsPage() {
    return (
        <div className="app-content main-content mt-0">
            <div className="side-app">
                <div className="main-container container-fluid">
                    <DahabCredentialsList />
                </div>
            </div>
        </div>
    );
}

export default DahabCredentialsPage;
